
















import { Component, Prop, Vue } from 'vue-property-decorator';
import ICommand from '../interfaces/command';
import HatsuiDataDisplay from '@/components/HatsuiDataDisplay';

@Component({
  components: {
    HatsuiDataDisplay,
  },
})
export default class CommandDisplay extends Vue {
  @Prop({ required: true })
  public command!: ICommand;

  public printData(jsonObj: JSON) {
    let returnString = '';
    for (const key of Object.keys(jsonObj)) {
      returnString += `${key}: ${(jsonObj as any)[key]}, `;
    }
    // TODO: Determine if there is a better way to do this parsing
    return returnString.substr(0, returnString.length - 2);
  }
}
